module.exports = __webpack_public_path__ + "img/alerts-2-mobile.9accf86d.gif";